import { logAiUsage } from './logAiUsage';

export function getRunpodConfig() {
  const apiKey = process.env.REACT_APP_RUNPOD_API_KEY;
  const apiUrl = process.env.REACT_APP_RUNPOD_API_URL;
  const model = process.env.REACT_APP_RUNPOD_MODEL
    || 'QuantTrio/Qwen3.6-35B-A3B-AWQ';

  if (!apiKey || !apiUrl) {
    throw new Error(
      'RunPod is not configured. Add REACT_APP_RUNPOD_API_KEY and REACT_APP_RUNPOD_API_URL to quote-form/.env and restart the dev server.',
    );
  }

  return { apiKey, apiUrl, model };
}

/** Model context is 8128 tokens total; cap output so prompts always fit. */
export const RUNPOD_MAX_OUTPUT_TOKENS = 4096;

async function parseRunpodError(res) {
  const text = await res.text().catch(() => '');
  let message = `RunPod API error (${res.status})`;
  try {
    const data = JSON.parse(text);
    message = data?.error?.message || data?.message || data?.detail || message;
  } catch {
    if (text) message = text.slice(0, 300);
  }
  return new Error(message);
}

export async function runpodComplete({
  system,
  user,
  maxTokens = 2048,
  temperature = 0.2,
  feature = 'unknown',
  userId = null,
  metadata = {},
  app = 'quote-form',
}) {
  const { apiKey, apiUrl, model } = getRunpodConfig();
  const safeMaxTokens = Math.min(maxTokens, RUNPOD_MAX_OUTPUT_TOKENS);
  const started = performance.now();

  try {
    const res = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${apiKey}`,
      },
      body: JSON.stringify({
        model,
        messages: [
          { role: 'system', content: system },
          { role: 'user', content: user },
        ],
        temperature,
        max_tokens: safeMaxTokens,
        stream: false,
        chat_template_kwargs: { enable_thinking: false },
      }),
    });

    if (!res.ok) {
      throw await parseRunpodError(res);
    }

    const data = await res.json();
    const text = data?.choices?.[0]?.message?.content || '';

    if (!text.trim()) {
      throw new Error('RunPod returned an empty response.');
    }

    const latencyMs = Math.round(performance.now() - started);
    await logAiUsage({
      app,
      feature,
      userId,
      model,
      system,
      user,
      output: text,
      status: 'ok',
      latencyMs,
      metadata,
    });

    return text;
  } catch (error) {
    const latencyMs = Math.round(performance.now() - started);
    await logAiUsage({
      app,
      feature,
      userId,
      model,
      system,
      user,
      output: '',
      status: 'error',
      error: error.message || 'Unknown error',
      latencyMs,
      metadata,
    });
    throw error;
  }
}

export function stripJsonFence(text) {
  let cleaned = text.trim();
  if (cleaned.startsWith('```')) {
    cleaned = cleaned.replace(/^```(?:json)?\s*/i, '');
    cleaned = cleaned.replace(/\s*```$/, '');
  }
  return cleaned.trim();
}
